import React, { FC, useState } from 'react';
import { Box, Divider, TextButton, Button, Loader } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import MobileFullScreenModalLayout from '../../MobileFullScreenModalLayout';

type Props = {
  title: string;
  content: any;
  dataHook?: string;
  onClear?: () => void;
  onApply?: () => void;
  onClose?: () => void;
  onBack?: () => void;
  selectedAmount?: number;
};

const MobileFilterModalLayout: FC<Props> = ({
  title,
  content,
  onClear,
  onApply,
  dataHook,
  onClose,
  onBack,
  selectedAmount,
}) => {
  return (
    <MobileFullScreenModalLayout
      title={title}
      content={content}
      dataHook={dataHook}
      onClose={onClose}
      onBack={onBack}
      footer={
        <FilterModalFooter
          selectedAmount={selectedAmount}
          onClear={onClear}
          onApply={onApply}
        />
      }
    />
  );
};

const FilterModalFooter: FC<
  Pick<Props, 'selectedAmount' | 'onClear' | 'onApply'>
> = ({ selectedAmount, onClear, onApply }) => {
  const { t } = useTranslation();
  const [inProgress, setInProgress] = useState(false);

  return (
    <Box direction="vertical">
      <Divider />
      <Box
        align="space-between"
        verticalAlign="middle"
        paddingTop="33px"
        paddingLeft="24px"
        paddingRight="24px"
        paddingBottom="33px"
      >
        {onClear ? (
          <TextButton
            underline="always"
            skin="dark"
            dataHook="clear-all-mobile-filter-button"
            onClick={() => {
              onClear();
            }}
          >
            {t('mobile-filter-clear-all-with-amount', { selectedAmount })}
          </TextButton>
        ) : (
          <span></span>
        )}
        {onApply && (
          <Button
            dataHook="apply-mobile-filter-button"
            onClick={() => {
              onApply();
              setInProgress(true);
            }}
            disabled={inProgress}
          >
            {inProgress ? <Loader size="tiny" /> : t('mobile-filter-apply')}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MobileFilterModalLayout;
